import { CardsBlockCss } from '../../styles'; // Importa estilos específicos para los bloques de tarjetas

// Props opcionales que se pueden pasar al componente
interface InformacionContactoProps {
  className?: string; // Permite agregar clases CSS adicionales desde el componente padre
}

const InformacionContacto: React.FC<InformacionContactoProps> = () => {
  return (
    <div
      // Contenedor principal del bloque
      className={`flex-1 bg-black text-white p-6 rounded-2xl shadow-2xl flex flex-col text-center justify-between ${CardsBlockCss.profesion}`}
      style={{ transform: "none" }} // Sin transformaciones CSS adicionales
    >
      {/* Título del bloque */}
      <h2 className="text-xl font-semibold">Información de Contacto</h2>

      {/* Mensaje de descripción */}
      <p className='px-4 py-2'>
        Estamos aquí para ayudarte. Si tienes alguna pregunta o necesitas asistencia, no dudes en ponerte en contacto con nosotros. Nuestro equipo estará encantado de ayudarte. Ahhh!!! Nos encantan las sugerencias, Ayudanos tu también
      </p>
    </div>
  );
};

export default InformacionContacto;

/* ${CardsBlockCss.profesion} 
   --> Esto aplica estilos predefinidos de CSS (por ejemplo, padding, bordes, sombras)
       específicos para los bloques de profesionales en la interfaz.
*/
